<section class="mt-8">
    <ul id="routes">
        <li>
            <div class="h-56 w-56 p-12 mt-12 bg-evaluationto text-gray-700 rounded" (click)="goToSummative()">
                <i class="fas fa-chart-bar text-3xl"></i>
            </div>
            <span class="font-light text-lg text-gray-700 cursor-default">Summative Evaluation (KPIs)</span>
        </li>
        <li>
            <div class="h-56 w-56 p-12 mt-12 bg-evaluationto text-gray-700 rounded" (click)="goToFormative()">
                <i class="fas fa-chart-bar text-3xl"></i>
            </div>
            <span class="font-light text-lg text-gray-700 cursor-default">Formative Evaluation</span>
        </li>
    </ul>
</section>
